const initGridFilters = () => {
  const atHomeBtn = document.querySelector('.careline-product-grid-filters .at-home');
  const outAboutBtn = document.querySelector('.careline-product-grid-filters .out-about');
  const seeAllBtn = document.querySelector('.careline-product-grid-filters .clear-filters');
  const productGridEl = document.querySelectorAll('.careline-product-grid .multicolumn-card');

  if(!atHomeBtn || !outAboutBtn || !seeAllBtn || !productGridEl) {
    return false;
  }

  const filterProductGrid = (filter) => {
    if(filter === 'clear'){
      productGridEl.forEach(product => {
        product.classList.remove('not-shown');
      }); 
    } else {
       productGridEl.forEach(product => {
        if(product.dataset.filter == filter) {
          product.classList.remove('not-shown');
        } else {
          product.classList.add('not-shown');
        }
      }); 
    }
  }

  const showAtHome = () => {
    atHomeBtn.classList.add('active');
    outAboutBtn.classList.remove('active');
    seeAllBtn.classList.remove('active');
    filterProductGrid('at-home');
  }

  const showOutAbout = () => {
    outAboutBtn.classList.add('active');
    atHomeBtn.classList.remove('active');
    seeAllBtn.classList.remove('active');
    filterProductGrid('out-about');
  }

  const clearGridFilters = () => {
    outAboutBtn.classList.remove('active');
    atHomeBtn.classList.remove('active');
    seeAllBtn.classList.add('active');
    filterProductGrid('clear');
  }

  atHomeBtn.addEventListener('click', showAtHome);
  outAboutBtn.addEventListener('click', showOutAbout);
  seeAllBtn.addEventListener('click', clearGridFilters);
  
}

initGridFilters();